module.exports = __webpack_public_path__ + "fonts/Graphik-Super.62dfe46c.woff2";